module.exports = __webpack_public_path__ + "static/media/polizaDisabled.a55f0642.svg";